'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactSlidedown = require('react-slidedown');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _components = require('../../components');

var _Changelog = require('./Changelog.css');

var _Changelog2 = _interopRequireDefault(_Changelog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A single item in the change log.
 */
var ChangelogItem = (_dec = (0, _reactCssModules2.default)(_Changelog2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ChangelogItem, _Component);

  //
  function ChangelogItem(props) {
    (0, _classCallCheck3.default)(this, ChangelogItem);
    return (0, _possibleConstructorReturn3.default)(this, (ChangelogItem.__proto__ || (0, _getPrototypeOf2.default)(ChangelogItem)).call(this, props));
  }
  //


  (0, _createClass3.default)(ChangelogItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          content = _props.content,
          idx = _props.idx;

      var dt = (0, _moment2.default)(id).format('MMM D, YYYY');
      var urlBase = 'https://www.asyousow.org/invest-your-values/download-data';
      return _react2.default.createElement(
        'div',
        { styleName: 'changelog-item', key: 'clgitm' + idx },
        _react2.default.createElement(
          'div',
          { styleName: 'changelog-item-title' },
          idx === 0 ? _react2.default.createElement(
            'span',
            null,
            'Current dataset: ',
            dt
          ) : dt
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'changelog-item-content' },
          _react2.default.createElement(
            'strong',
            null,
            'Description:'
          ),
          ' ',
          content
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'changelog-item-links' },
          _react2.default.createElement(
            'div',
            { styleName: 'changelog-item-link' },
            _react2.default.createElement(
              _components.Link,
              {
                to: urlBase + '?company=' + id,
                title: 'Invest Your Values company screens download ' + id,
                log: _analytics2.default.eventDownloadChangelogExcel(id + ' company screens'),
                xstrong: true
              },
              'Company lists ',
              id,
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-download' }),
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-file-excel-o' })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'changelog-item-link' },
            _react2.default.createElement(
              _components.Link,
              {
                to: urlBase + '?shareclass=' + id,
                title: 'Invest Your Values shareclass results download ' + id,
                log: _analytics2.default.eventDownloadChangelogExcel(id + ' shareclass results'),
                xstrong: true
              },
              'Shareclass results ',
              id,
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-download' }),
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-file-excel-o' })
            )
          )
        )
      );
    }
  }]);
  return ChangelogItem;
}(_react.Component), _class2.propTypes = {
  id: _react.PropTypes.string.isRequired,
  content: _react.PropTypes.string.isRequired,
  idx: _react.PropTypes.number.isRequired
}, _temp)) || _class);

/**
 * A component to display a list of changelog items.
 * The first item is always displayed; other items are displayed if the user
 * clicks a button.
 */

var Changelog = (_dec2 = (0, _reactCssModules2.default)(_Changelog2.default, { allowMultiple: true }), _dec2(_class3 = function (_Component2) {
  (0, _inherits3.default)(Changelog, _Component2);

  function Changelog(props) {
    (0, _classCallCheck3.default)(this, Changelog);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Changelog.__proto__ || (0, _getPrototypeOf2.default)(Changelog)).call(this, props));

    _this2.openSlidedown = function () {
      _this2.setState({ open: true });
    };

    _this2.state = {
      open: false
    };
    return _this2;
  }
  //


  (0, _createClass3.default)(Changelog, [{
    key: 'render',

    //
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'changelog-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'changelog-title' },
          'Download dataset as spreadsheet'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'changelog-info' },
          'We update Invest Your Values data once a month. Each month, we use the most recent fund holdings data available from our data provider Morningstar. We also use the most recent versions of our various company lists. Any changes to the company lists or fund rating methodologies will be reflected below.'
        ),
        _react2.default.createElement(ChangelogItem, { id: _config2.default.changelog[0].id, content: _config2.default.changelog[0].content, idx: 0 }),
        !this.state.open ? _react2.default.createElement(
          'button',
          {
            styleName: 'changelog-open-button',
            onClick: this.openSlidedown
          },
          'See older',
          _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-caret-down' })
        ) : null,
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          this.state.open ? _config2.default.changelog.slice(1).map(function (c, idx) {
            return _react2.default.createElement(ChangelogItem, { id: c.id, content: c.content, idx: idx + 1 });
          }) : null
        )
      );
    }
  }]);
  return Changelog;
}(_react.Component)) || _class3);
exports.default = Changelog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/Changelog/Changelog.js
// module id = 1351
// module chunks = 0